import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { GET_MODULES, GET_PERMISSIONS, GET_PERMISSION_BY_ID, GET_PROFILES, GET_PROFILE_BY_ID } from '../graphql/queries/roles.query';
import { ACTIVATE_OR_DEACTIVATE, CLONE_PROFILE, CREATE_PROFILE, REMOVE_PROFILE, UPDATE_PERMISSIONS } from '../graphql/mutation/roles.mutation';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(private apollo: Apollo) {}

  profiles(search : any): Observable<any> {
    return this.apollo
      .use('hrms')
      .query<any>({
        query: GET_PROFILES,
        variables: {
          search
        },
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result) => result.data?.roles || [])
      );
  }

  modules(): Observable<any> {
    return this.apollo
      .use('hrms')
      .query<any>({
        query: GET_MODULES,
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result) => result.data?.getModulesList || [])
      );
  }

  profile(id: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .query<any>({
        query: GET_PROFILE_BY_ID,
        variables: {
          id
        },
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result) => result.data?.role || [])
      );
  }

  permissions(search : any): Observable<any> {
    return this.apollo
      .use('hrms')
      .query<any>({
        query: GET_PERMISSIONS,
        variables: {
          search
        },
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result) => result.data?.permissions || [])
      );
  }

  getModuleData(profileId : any): Observable<any> {
    return this.apollo
      .use('hrms')
      .query<any>({
        query: GET_PERMISSION_BY_ID,
        variables: {
          profileId
        },
        fetchPolicy: 'no-cache'
      })
      .pipe(
        map((result) => {
          const data = result.data?.getPermissionsByProfile || [];
          return data;
        })
      );
  }

  createProfile(createRoleInput: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: CREATE_PROFILE,
        variables: {
          createRoleInput
        }
      })
      .pipe(
        map((result: any) => result.data?.createRole || [])
      );
  }
  
  activateOrDeactivateUser(userId: any, status: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: ACTIVATE_OR_DEACTIVATE,
        variables: {
          userId,
          status
        }
      })
      .pipe(
        map((result: any) => result.data?.activateOrDeactivateUser || [])
      );
  }

  assignBulkPermissions(input: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: UPDATE_PERMISSIONS,
        variables: {
          input
        }
      })
      .pipe(
        map((result: any) => result.data?.assignBulkPermissions || [])
      );
  }
  
  removeProfile(id: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: REMOVE_PROFILE,
        variables: {
          id
        }
      })
      .pipe(
        map((result: any) => result.data?.removeProfile || [])
      );
  }

  cloneProfile(profileId: any, profileName: any, description: any): Observable<any> {
    return this.apollo
      .use('hrms')
      .mutate({
        mutation: CLONE_PROFILE,
        variables: {
          profileId,
          profileName,
          description
        }
      })
      .pipe(
        map((result: any) => result.data?.removeProfile || [])
      );
  }
}